import { Button } from "@material-ui/core";
import React, { useRef } from "react";
import { useEffect } from "react";
import { useState } from "react";

const LS_NAME = 'audioMessageRate';

export default function({url, mimeType = "audio/ogg"}) {
    const audioRef = useRef(null);
    const [audioRate, setAudioRate] = useState( parseFloat(localStorage.getItem(LS_NAME) || "1") );
    const [showButtonRate, setShowButtonRate] = useState(false);

    useEffect(() => {
        audioRef.current.playbackRate = audioRate;
        localStorage.setItem(LS_NAME, audioRate);
    }, [audioRate]);

    useEffect(() => {
        audioRef.current.onplaying = () => {
            setShowButtonRate(true);
        };
        audioRef.current.onpause = () => {
            setShowButtonRate(false);
        };
        audioRef.current.onended = () => {
            setShowButtonRate(false);
        };
    }, []);

    const toogleRate = () => {
        let newRate = null;

        switch(audioRate) {
            case 0.5:
                newRate = 1;
                break;
            case 1:
                newRate = 1.5;
                break;
            case 1.5:
                newRate = 2;
                break;
            case 2:
                newRate = 0.5;
                break;
            default:
                newRate = 1;
                break;
        }
        
        setAudioRate(newRate);
    };

    return (
        <div style={{ width: 260, maxWidth: "72vw", padding: "2px 0 10px" }}>
            <audio
                ref={audioRef}
                controls
                style={{ width: "100%", height: 36, display: "block" }}
            >
                <source src={url} type={mimeType}></source>
            </audio>
            {showButtonRate && (
                <Button
                    size="small"
                    variant="outlined"
                    style={{
                        marginLeft: 4,
                        marginTop: 6,
                        minWidth: 44,
                        height: 26,
                        padding: "2px 8px",
                        fontSize: 12,
                        lineHeight: 1
                    }}
                    onClick={toogleRate}
                >
                    {audioRate}x
                </Button>
            )}
        </div>
    );
}
